import reducers from "./reducers";

const eventsReducers = {
  contestant: reducers.getContestantReducer,
  event: reducers.getEventReducer,
  events: reducers.getEventsReducer,
};

export { eventsReducers };
